<script>
export default {
  name: 'TwoLevelTabs',
  props: {
    // v-model 相当（上段）
    modelValueTop: {
      type: String,
      required: true,
    },
    // v-model 相当（下段）
    modelValueBottom: {
      type: String,
      required: true,
    },
    // 上段タブ: [{ label, name }]
    topTabs: {
      type: Array,
      required: true,
    },
    // 下段タブ: { [topName]: [{ label, name }] }
    bottomTabs: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      topValue: this.modelValueTop,
      bottomValue: this.modelValueBottom,
    }
  },

  watch: {
    // 親→子 同期
    modelValueTop(val) {
      this.topValue = val
    },
    modelValueBottom(val) {
      this.bottomValue = val
    },

    // 子→親 同期（上段）
    topValue(val) {
      // 上段が変わったら下段を初期化（元コード準拠）
      const list = (this.bottomTabs && this.bottomTabs[val]) || []

      if (this.bottomValue) {
        const exists = list.some((t) => t.name === this.bottomValue)
        if (!exists) {
          if (list[0]) this.bottomValue = list[0].name
        }
      } else {
        if (list[0]) this.bottomValue = list[0].name
      }

      this.$emit('update:modelValueTop', val)
      // 下段が内部で変更された場合は bottomValue の watcher で emit されます
    },

    // 子→親 同期（下段）
    bottomValue(val) {
      this.$emit('update:modelValueBottom', val)
    },
  },
}
</script>

<template>
  <div class="two-level-tabs">
    <!-- 上段 -->
    <el-tabs v-model="topValue" type="card">
      <el-tab-pane
        v-for="tab in topTabs"
        :key="tab.name"
        :label="tab.label"
        :name="tab.name"
      />
    </el-tabs>

    <!-- 下段 -->
    <el-tabs v-model="bottomValue" type="card">
      <el-tab-pane
        v-for="tab in (bottomTabs[topValue] || [])"
        :key="tab.name"
        :label="tab.label"
        :name="tab.name"
      />
    </el-tabs>
  </div>
</template>

<style scoped>
.two-level-tabs {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

:deep(.el-tabs__item) {
  color: #666;
  background-color: #f5f5f5;
}

:deep(.el-tabs__item.is-active) {
  color: #000;
  background-color: #fff;
}
</style>
